import { Page as Component } from "~/components/specifics/settings/company_vendors/Page";
import { useCompanyVendors } from "~/hooks/useCompanyVendors";
import useItandiAccount from "~/hooks/useItandiAccount";

export function Page() {
	const { data: currentAccount } = useItandiAccount().currentAccount();
	const { data: companyVendors } = useCompanyVendors().index();

	if (currentAccount === null || companyVendors === null) {
		return null;
	}

	return (
		<Component
			companyVendors={companyVendors}
			currentAccount={currentAccount}
		/>
	);
}
